// import axios from 'axios'
import apiAxios from '../../services/apiAxios';

const state = {
    username: '',
    tokenString: '',
    /*hashCode: '',*/
};

const mutations = {
  'LOGIN'(state, params) {
    state.username = params.username;
    state.tokenString = params.tokenString;
    /*state.hashCode = params.hashCode;*/
  },
  'LOGOUT'(state) {
    state.username = '';
    state.tokenString = '';
    /*state.hashCode = '';*/
  },
};

const actions = {
  login ( { commit, rootState }, credenciales ) {
      return new Promise((resolve, reject) => {
        commit('LOGOUT');
        
        var credencialesLogin = {
          username: credenciales.username,
          password: credenciales.password,
        }
        
        if (rootState.settings.sinConexion) {
          var params = {
            username: credenciales.username,
            tokenString: '999999999999',
          }
          commit('LOGIN', params);

          resolve();

        } else {
          apiAxios.post('auth/login-pwa', credencialesLogin)
          .then(res => {
            var params = {
              username: credenciales.username,
              tokenString: res.data.token,
            }
            commit('LOGIN', params);

            resolve();
          })
          .catch(error =>  {
            let errorMessage = 'Se produjo un error al intentar loguear el usuario.'
            
            if (error) {
              if (error.response) {
                if (error.response.data) {
                  errorMessage = error.response.data;
                }
              }
            }

            reject(errorMessage);
          });
        }
      });
  },
  logout: ({commit}) => {
      commit('LOGOUT');
  },
};

const getters = {
  loggedIn(state) {
    if (state.username != '') {
        return true;
    } else {
        return false;
    }
  },
  username (state) {
    return state.username;
  },
  tokenString (state) {
    return state.tokenString;
  },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js